import gql from 'graphql-tag';

export default () => {
  const getProvSequenceConfig = 'getProvSequenceConfig(dummy: "")';
  return gql`
    query {
      ${getProvSequenceConfig} {
        id
        orderType
        serviceType
        provisioningSequence
        sequences {
          index
          apiName
          apiCategory
          status
          onErrorResubmit
          validateOnly
          queueName
          merchantName
          synchronousResponse
          errorApiName
          waitTimeBeforeNext
          onManualProvisioningOnly
          retryCountOnError
          restartApiOnError
          errorReason
          objectType
          provSequenceData {
            index
            attribute
            value
          }
          prerequisiteInboundApis {
            index
            apiName
          }
        }
        inputs {
          index
          apiName
          serviceTypes
          status
          action
          level
          merchantName
          executeOnError
          manualProvisioningApi
        }
      }
    }
  `;
};
